import { http } from "Utils/http";
import { Form, Tabs, Tab, Row, Col, Card,Dropdown,Button, Stack,Modal,CloseButton, DropdownButton } from "react-bootstrap";
import { useState, useEffect, useReducer, useRef} from "react";
import ListUserTable from "Containers/Private/User/List/ListUserTable";
import {useLocation } from 'react-router-dom';
import { STATUSES } from "Utils/constants";
import {store} from 'Store';
import {setGlobalErrorStatus, setGlobalSuccessStatus} from 'Components/StatusHandling'
import { useDispatch } from "react-redux"
import {Link, useNavigate} from 'react-router-dom';
import { ERROR_MESSAGES } from "Utils/constants";
import { NavLink } from "react-router-dom";
import {Helmet} from "react-helmet";
import axios from "axios";
//import { Api, TableauViz } from '@tableau/embedding-api-react';
//import DynamicFormPopup from "Components/Popup/DynamicFormPopup";
import TableauView from "./TableauView";
import { TableauViz } from "@tableau/embedding-api-react";







const TableauReportView = (props) => {
   //console.log(props);
    const navigate = useNavigate();
    const t = window.tableau;
    let location = useLocation();
    var passedData = location.state;
    //console.log("PASSED DATA");
    //console.log(passedData);
   
    //const [isLoading, setIsLoading] = useState(true)

    var dispatch = useDispatch();


    const loginState = store.getState().loginInfo;

    const [isLoading, setIsLoading] = useState(true);
    
    var categories = {};
    var timePeriods = {};
    var reports = {};

    var viz = null;

    
    //var scriptUrl = null;
    //var viewUrl = null;

    //const [viz, setViz] = useState(null);
    const [viewUrl, setViewUrl] = useState(null);
    const [viewMap, setViewMap] = useState(null);
    const [scriptUrl, setScriptUrl] = useState(null);
    const [ticket, setTicket] = useState(null);
    const [name, setName] = useState(null);
    const [defaultView, setDefaultView] = useState(null);
    const [reportId, setReportId] = useState(JSON.parse(localStorage.getItem("newTabState")).reportId);
    const [cats, setCats] = useState({});
    const [tps, setTps] = useState({});
    const [rps, setRps] = useState({});
const [reportLink, setReportLink] = useState(null);
    const [showTermsPopup, setShowTermsPopup] = useState(true);
const [token, setToken] = useState(null);

    useEffect(() => {
        if(reportId!=null){
            
            //loadReportView(reportId);

        }
    }, []);

    const getReportView = async (reportId) => {
    
            var url = '/api/interactiveReports/viewTaleauReport';
            const loginState = store.getState().loginInfo;
            var data = {
                reportId: reportId
            }
    
            return http.post(url, data, {
                headers: {
                    "Authorization": "Bearer " + loginState.token
                    //"Referrer-Policy": "strict-origin-when-cross-origin"
                }
            });
        }
    const loadReportView = async (reportId) => {
        
        var reports = {};
        
        return getReportView(reportId).then((res) => {
            //console.log("getFormData ", res);
            if (res.status != 1) {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.DATA_ERROR.title,
                        msg: res.globalErrorMessageList[0],
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
            }
            else {
                setToken(res.data.token);
                setReportLink(res.data.viewMap[res.data.defaultView]);
                
            }
            return res;
        }).catch((error) => {
            //console.log("Error caught while loading data: " + error);

            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    msg: ERROR_MESSAGES.DATA_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
        
    };

    return (

        <Row>
            <Row >
                    <Col xl={11} lg={11} md={11} sm={12} className="no-left-nav">
                        
                        <Card className="p-4" >
                            <Card.Body className="text-start">
                                <Row>
                                    <h1 id="mainContent" className="header1 text-start mb-3 blue bold" >Interactive Reports</h1>
                                  
                                </Row>
                                <Row>
                                    <Form>
                                        
                                            {
                                                reportId != null
                                                ?

                                                   /* <TableauViz
                                                        src="https://tableau.pshdemo.com/views/AHRQLeadershipOverviewDashboard/AHRQLeadershipDashboardOverview"
                                                        toolbar="hidden"
                                                        token={token}
                                                        onFirstInteractive={async (event) => {
                                                            const { target: viz } = event;
                                                            const dashboard = viz.workbook.activeSheet;
                                                            const filters = await dashboard.getFiltersAsync();
                                                            //console.log('filters', filters);
                                                        }}
                                                        onvizloaderror={async (event)=> {
                                                            //console.log(event);
                                                        }}
                                                    />*/
              
                                                    <TableauView reportId={reportId}></TableauView>
                                                :   null
                                            }

                                    </Form>
                                </Row>
                                    
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            
            </Row>


    )
}

export default TableauReportView;